<template>
  <div class="container decentered side-filters-layout">
    <div
      v-if="!areFiltersCollapsed"
      class="filter-column hidden-sm hidden-xs"
    >
      <div class="section-toolbar">
        <button
          class="button-reset"
          @click="onToggleFilters"
        >
          <i
            class="fa fas"
            :class="areFiltersCollapsed ? 'fa-sliders' : 'fa-times'"
            aria-hidden="true"
          ></i>
          Filtros
        </button>
      </div>
      <dep-list-filter
        v-on:button-apply="onApplyFilters"
        :button-text="filtersButtonText"
        :show-button="showFiltersButton"
        :module-name="moduleName"
        :is-disabled-button="disableFiltersButton"
      />
    </div>

    <div class="layout-content">
      <webon-table
        v-if="displayTable"
        :module-name="moduleName"
        v-bind="webonTableProps"
        v-on="webonTableProps.events"
        :table-id="tableId"
        ref="webonTable"
      >
        <div slot="toolbar-start">
          <button
            v-if="areFiltersCollapsed"
            class="button-reset"
            style="margin-right: 10px"
            @click="onToggleFilters"
          >
            <i
              class="fa fas"
              :class="areFiltersCollapsed ? 'fa-sliders' : 'fa-times'"
              aria-hidden="true"
            />
            Filtros
          </button>
        </div>
        <div slot="toolbar">
          <slot name="webon-table-toolbar"></slot>
        </div>
      </webon-table>
    </div>
  </div>
</template>

<script>
import DepListFilter from "@/components/global/depListFilter";
import WebonTable from "@/components/global/webon/webon-table/WebonTable";

export default {
  name: "side-filters-layout",
  components: {
    DepListFilter,
    WebonTable,
  },
  props: {
    filtersButtonText: {
      type: String,
      default: "Buscar",
    },
    webonTableProps: {
      type: Object,
    },
    moduleName: {
      type: String,
    },
    displayTable: {
      type: Boolean,
      default: true,
    },
    onApplyFilters: {
      type: Function,
      default: () => {
        //TODO: Show error
      },
    },
    showFiltersButton: {
      type: Boolean,
      default: false,
    },
    disableFiltersButton: {
      type: Boolean,
      default: false,
    },
    tableId: {
      type: String,
      default: "webon-table",
    },
  },
  data() {
    return {
      areFiltersCollapsed: false,
    };
  },
  methods: {
    onToggleFilters() {
      this.areFiltersCollapsed = !this.areFiltersCollapsed;
    },
  },
};
</script>

<style lang="scss">
.side-filters-layout {
  height: 100%;
  display: flex;

  .layout-content {
    flex-grow: 2;
    margin-left: 20px;
    height: 100%;
    overflow-y: auto;
  }

  .filter-column {
    height: 100%;
    display: -webkit-box;
    flex-direction: column;

    .filters-panel {
      flex-grow: 2;
      margin-bottom: 10px;
    }
  }
}
</style>
